/*
  ElettroGaming – movimento
  - rivela le sezioni con una dissolvenza morbida quando entrano nello schermo
  - dà profondità all'hero seguendo il mouse (solo con puntatore preciso)
  Nessuna dipendenza. Rispetta "riduci animazioni" e non fa nulla nell'editor del tema.
*/
(function () {
  'use strict';

  var root = document.documentElement;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasObserver = 'IntersectionObserver' in window;
  var observer = null;

  function reveal(el) {
    el.classList.add('is-visible');
  }

  function getObserver() {
    if (observer || !hasObserver) return observer;
    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0, rootMargin: '0px 0px -8% 0px' }
    );
    return observer;
  }

  function watch(el) {
    if (el.classList.contains('is-visible') || el.__egWatched) return;
    el.__egWatched = true;
    if (reduceMotion || !hasObserver) {
      reveal(el);
      return;
    }
    getObserver().observe(el);
  }

  function setup(scope) {
    scope = scope || document;

    // Sezioni del tema (liste prodotto, banner, testi) sulla home: dissolvenza semplice.
    var main = document.querySelector('main[data-template="index"]');
    if (main && root.classList.contains('eg-js')) {
      main.querySelectorAll(':scope > .shopify-section:not(:first-child)').forEach(function (section) {
        if (section.querySelector('[data-eg-own]') || section.hasAttribute('data-eg-reveal')) return;
        section.setAttribute('data-eg-reveal', '');
      });
    }

    scope.querySelectorAll('[data-eg-reveal], [data-eg-watch]').forEach(watch);
  }

  function tilt() {
    if (reduceMotion || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var hero = document.querySelector('.eg-hero');
    if (!hero || hero.__egTilt) return;
    hero.__egTilt = true;
    var frame = null;
    hero.addEventListener('pointermove', function (event) {
      if (frame) return;
      frame = requestAnimationFrame(function () {
        frame = null;
        var rect = hero.getBoundingClientRect();
        var x = (event.clientX - rect.left) / rect.width - 0.5;
        var y = (event.clientY - rect.top) / rect.height - 0.5;
        hero.style.setProperty('--mx', x.toFixed(3));
        hero.style.setProperty('--my', y.toFixed(3));
      });
    });
    hero.addEventListener('pointerleave', function () {
      hero.style.setProperty('--mx', 0);
      hero.style.setProperty('--my', 0);
    });
  }

  function init() {
    setup(document);
    tilt();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Editor del tema: sezioni ricaricate dinamicamente
  document.addEventListener('shopify:section:load', function (event) {
    setup(event.target);
    tilt();
  });
})();
